import img from "../../../../assets/icons/Ubuntu.svg";
import offIcon from "../../../../assets/icons/shutdown.svg";
import counterIcon from "../../../../assets/icons/Contour.svg";
import { Dropdown, Modal, Tooltip } from "antd";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/dashboard-modal-delete.svg";
import { useDispatch, useSelector } from "react-redux";
import { deleteSession, getSessions, set_active_session } from "../../../../data/slices/sessions";
import { useLocation, useNavigate } from "react-router-dom";
import SessionCounter from "../SessionCounter/SessionCounter";
import { useTranslation } from "react-i18next";

const DesktopPreview = ({ session, screenshot }) => {
  const sessionName = session?.name || "_";
  const sessionIsActive = !!session?.podRunningAt || session?.isConnected;
  const sessionIcon = session?.template?.imageIconUrl || session?.imageIconUrl;

  return (
    <div className="desktop-preview">
      <div className="preview-header">
        <div className="preview-icon">
          <img src={sessionIcon || img} alt="" />
        </div>
        <div className="preview-title">
          <Tooltip title={sessionName}>
            <h4>{sessionName}</h4>
          </Tooltip>
          <div className="preview-timer">
            <img src={counterIcon} alt="timer" />
            <span>{sessionIsActive ? <SessionCounter session={session} /> : "00h 00m 00s"}</span>
          </div>
        </div>
      </div>
      <div className="preview-screenshot">
        {screenshot ? (
          <img src={screenshot} alt="Desktop preview" />
        ) : (
          <div className="no-screenshot">No preview available</div>
        )}
      </div>
    </div>
  );
};

const ActiveDesktop = ({ session }) => {
  const { t } = useTranslation("other");
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const sessionName = session?.name || "_";
  const sessionIcon = session?.template?.imageIconUrl || session?.imageIconUrl;
  const sessionIsActive = !!session?.podRunningAt || session?.isConnected;
  const { sessionScreenshots } = useSelector((state) => state.sessions);
  const screenshot = sessionScreenshots?.[session?.id];

  const showDeleteConfirm = () => {
    confirm({
      centered: true,
      title: t("other-15"),
      content: "",
      okText: t("other-16"),
      okType: "danger",
      cancelText: t("other-17"),
      maskClosable: true,
      wrapClassName: "modal_delete_multiple",
      icon: (
        <div className="delete-model-icon">
          <DeleteIcon />
        </div>
      ),
      onOk() {
        dispatch(deleteSession({ name: session.name, namespace: session.namespace }));
        if (
          pathname === `/control/${session.name}` ||
          pathname === `/control/proxy/${session.name}`
        ) {
          navigate("/");
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      autoFocusButton: "cancel"
    });
  };
  const goControl = () => {
    const isProxy = session?.connectionURL;
    if (isProxy) {
      navigate(`/control/proxy/${session.name}`);
    } else {
      dispatch(set_active_session(session));
      if (pathname !== `/control/${session.name}`) {
        navigate(`/control/${session.name}`, { state: session });
      }
    }
    //to check the existence of this session
    dispatch(getSessions());
  };

  const getClassName = () => {
    if (pathname === `/control/${session.name}` || pathname === `/control/proxy/${session.name}`) {
      return "_active";
    } else {
      return null;
    }
  };

  // Create dropdown menu content
  const dropdownContent = () => <DesktopPreview session={session} screenshot={screenshot} />;

  return (
    <Dropdown
      trigger={["hover"]}
      mouseEnterDelay={0.7}
      placement="bottomLeft"
      dropdownRender={dropdownContent}
      destroyPopupOnHide
      overlayClassName="desktop-preview-dropdown"
    >
      <div className={`active_desktop ${getClassName()}`} onClick={goControl}>
        <div className="desktop_left">
          <div className="desktop_left-icon">
            <img src={sessionIcon || img} alt="" />
          </div>
          <div className="desktop_left-info">
            <Tooltip title={sessionName}>
              <p className="desktop_name">{sessionName}</p>
            </Tooltip>

            <p className="desktop_time">
              <img src={counterIcon} alt="error" />
              {sessionIsActive ? <SessionCounter session={session} /> : "00h 00m 00s"}
            </p>
          </div>
        </div>
        <div className="desktop_right">
          <img
            src={offIcon}
            alt=""
            onClick={(e) => {
              e.stopPropagation();
              showDeleteConfirm();
            }}
          />
        </div>
      </div>
    </Dropdown>
  );
};

export default ActiveDesktop;
